export const UPDATE_LOCATION = 'UPDATE_LOCATION';
export const SET_INITIAL_LOCATION = 'SET_INITIAL_LOCATION';